import React from 'react'

import { ErrorBoundary } from '@sentry/react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import App from 'src/Containers/App/App'
import { setupStore } from 'src/Redux/index'
import TagManagerContextProvider from 'src/Helpers/TagManager/TagManagerContextProvider'
import { initSourceBuster } from 'src/Helpers/TagManager/sourceBusterInit'
import { GrowthProvider } from 'src/Helpers/GrowthBook'

import { api } from './Services/api'
import browserHistory from './Router/browser-history'
import HistoryRouter from './Router/history-router'
import { ErrorPage } from './Components/ErrorBoundary'
import { StyleSheetManagerWrapper } from './Helpers/StyleSheetManagerWrapper'
import { IntercomWrapper } from './Containers/App/IntercomWrapper'

initSourceBuster()

export const { store, persistor } = setupStore()
api.setStore && api.setStore(store)

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <IntercomWrapper>
        <PersistGate loading={null} persistor={persistor}>
          <StyleSheetManagerWrapper>
            <TagManagerContextProvider>
              <HistoryRouter history={browserHistory}>
                <GrowthProvider>
                  <ErrorBoundary
                    fallback={<ErrorPage />}
                    onError={(error) => {
                      const message =
                        error instanceof Error ? error.message : ''
                      const isChunkLoadFailure =
                        message.includes('MIME type') ||
                        message.includes('module script')
                      if (isChunkLoadFailure) {
                        window.location.reload()
                      }
                    }}
                  >
                    <App />
                  </ErrorBoundary>
                </GrowthProvider>
              </HistoryRouter>
            </TagManagerContextProvider>
          </StyleSheetManagerWrapper>
        </PersistGate>
      </IntercomWrapper>
    </Provider>
  </React.StrictMode>,
)
